import React from 'react'
import { DeliveryConfirmation } from './DeliveryConfirmation'
import { CustomerInfo } from './CustomerInfo'
import { ShipmentDate } from './ShipmentDate'
import { Col, Row } from 'react-bootstrap'

export const AdvanceShippingOption = () => {
  return (
    <div>
      <Row className="gap-2">
        <Col md={12}>
          <CustomerInfo />
        </Col>
        <Col md={12}>
          <DeliveryConfirmation />
        </Col>

        <Col md={12}>
          <ShipmentDate />
        </Col>
      </Row>
    </div>
  )
}
